export default {
    page: {
        order: 'Order',
        revision: 'revision',
        guide: 'guide',
        serve: 'Serve',
        companyProfile: 'Company Profile',
        onlineService: 'online service',
        financialDetails: 'Financial Details',
        recharge: 'Recharge',
        withdraw: 'Withdraw',
        accountsCanBeReceived: 'Accounts can be received',
        inviteLink: 'Referral Link',
        treasurePlate: 'Treasure Plate',
        live: 'Live',
        password: 'Login Password',
        passwordFund: 'Withdrawal Password',
    },
    side: {
        ShareGuys: '分享给好友',
        main: '首页',
        trade: '交易管理',
        tradeOrder: '订单列表',
        tradeRecharge: '充值管理',
        tradeWithdraw: '提现管理',
        tradeControl: '交易控制',
        tradeAmount: '金额调整',
        tradeStatistics: '统计报表',
        tradeReport: '代理报表',
        tradeReportDaily: '代理日报表',
        tradeReportMonthly: '代理月报表',
        commodity: '商品管理',
        commodityList: '商品列表',
        commoditySort: '商品分类',
        member: '会员管理',
        memberList: '会员列表',
        memberSort: '会员等级',
        memberLevel: '会中层级',
        content: '内容管理',
        contentNotice: '公告管理',
        contentText: '文本管理',
        contentAd: '首页轮播图',
        contentLogo: 'LOGO',
        power: '权限管理',
        powerList: '访问权限',
        powerAdmin: '系统用户',
        system: '系统管理',
        systemMenu: '系统菜单管理',
        systemParameter: '系统参数配置',
        systemLog: '系统操作日志'
    },
    but: {
        login: 'Login',
        register: 'Register',
        continue: 'Continue',
        recharge: 'Recharge',
        withdraw: 'Withdraw',
        copy: 'Copy',
        copied: 'Copied',
        downloadQr: 'Download QR',
        buyNow: 'Activate now',
        close: 'Close',
        upload: 'Choose image',
        reupload: 'Choose again',
        uploading: 'Uploading...',
        save: 'Save',
    },
    footer: {
        homePage: 'Home',
        product: 'Product',
        TreasurePlate: '聚宝盘',
        mine: 'Mine'
    },
    title: {
        account: 'Username',
        password: 'Password',
        confirmPassword: 'Confirm password',
        inviteCode: 'Invite code',
    },
    placeholder: {
        account: 'Username (combination of numbers and letters)',
        password: 'please enter your password',
        agree: 'I agree',
        userAgreement: 'User Agreement',
        user: 'Vui lòng nhập số điện thoại của bạn',
        confirmPassword: 'Please re-enter your password',
        invitation: 'Enter the invitation code',
        rechargeAmount: 'Enter the recharge amount',
        firstSettingFund: 'Leave blank for first-time setup',
    },
    text: {
        MySubordinates: 'My Subordinates',
        MyTeam: 'My Team',
        totalAccountCount: 'Total accounts',
        registerTime: 'Registered at',
        noReferralMembers: 'No registered accounts yet',
        noMore: 'No more',
        subordinatesDesc: 'Accounts registered directly via your invite link',
        teamDesc: 'All accounts in your referral tree, including indirect members',
        TodayOrder: '今天订单',
        TodayCommission: '今天佣金',
        MonthRecharge: 'Month recharge',
        MonthCommission: 'Month commission',
        MonthDirectRecharge: 'Monthly recharge',
        MonthDirectCommission: 'Monthly commission',
        monthDirectRechargeDesc: 'Successful recharge totals this month from your direct subordinates (grouped by account)',
        noMonthDirectRecharge: 'No direct subordinate recharge this month',
        estimatedCommission: 'Est. commission',
        loading: 'Loading...',

        workingCapital: 'Working Capital',
        quickAction: 'Quick Action',
        liveModeLowLatency: 'Low latency',
        liveModeStable: 'Stable',
        liveFlvUnsupported: 'FLV is not supported in this browser. Try Low latency or use Chrome / Edge.',
        liveFlvError: 'Stable mode failed. Switch back to Low latency or retry later.',
        liveTapToPlay: 'Tap the video to play',
        liveTapForSound: 'Tap to unmute',
        amountOfWorkingCapital: 'Amount of working capital',
        currentFrozenBalance: 'Current frozen balance',
        orderToday: 'Order today',
        roseToday: 'Rose today',
        allOrders: 'All orders',
        totalCommission: 'Total commission',
        order: 'Order',
        revision: 'Receiving account',
        guide: 'guide',
        serve: 'Serve',
        companyProfile: 'Company Profile',
        onlineService: 'online service',
        financialDetails: 'Financial Details',
        receiveQrTip: 'Upload your Alipay and WeChat payment QR codes for platform use',
        uploadAlipayQr: 'Tap to upload Alipay QR',
        uploadWxQr: 'Tap to upload WeChat QR',
        receiveQrEmpty: 'Please select a QR image to upload',
        receiveQrTypeError: 'Only jpg/png/gif/webp images are allowed',
        receiveQrSizeError: 'Image must be under 2MB',
        rechargeAnnouncement: 'Note: Because the amount of deposit information is too large, you must carefully check your account card number before depositing. This platform changes account numbers from time to time. If you have any questions, please click online customer service！',
        rechargeLimit: 'Online deposit1 (50k to 300 million)',
        depositMethodSelect: 'Choose a deposit method',
        depositMethod: 'deposit method',
        serveText: 'Congratulations, you have successfully logged in!',
        inviteLinkTip: 'Share the link or QR code below to invite friends to register',
        inviteRegisterLink: 'Invitation registration link',
        inviteCodeTip: 'Your invite code is your account UUID; friends can use the link above or enter it manually',
        inviteFromLink: 'You are registering via a referral link; invite code is pre-filled',
        copySuccess: 'Link copied to clipboard',
        copyFailed: 'Copy failed, please copy manually',
        servicePlan: 'Service plans',
        monthlyPlan: 'Monthly plan',
        quarterlyPlan: 'Quarterly plan',
        halfYearPlan: 'Half-year plan',
        yearPlan: 'Annual plan',
        monthlyDays: 'Valid for 31 days, stackable',
        quarterlyDays: 'Valid for 93 days (3 months), stackable',
        halfYearDays: 'Valid for 186 days (6 months), stackable',
        yearDays: 'Valid for 365 days (12 months), stackable',
        planDaysFallback: 'Valid for {days} days, stackable',
        currentValidUntil: 'Valid until',
        notActivated: 'Not activated',
        serviceActive: 'Active',
        serviceExpired: 'Expired',
        rmb: 'CNY',
        buying: 'Processing…',
        buySuccess: 'Activated successfully',
        subscribeTip: 'Select a plan and payment method, then pay to activate. Duration stacks on remaining time.',
        payMethod: 'Payment method',
        payAlipay: 'Alipay',
        payWxpay: 'WeChat Pay',
        payRedirecting: 'Redirecting to payment…',
        payCreateFailed: 'Failed to create payment order. Please try again.',
        payPendingTip: 'If payment is complete, your validity will update shortly. Refresh if it does not change.',
        payScanWxTip: 'Scan the QR code with WeChat to complete payment',
        payScanAlipayTip: 'Scan the QR code with Alipay to complete payment',
        payWaiting: 'Waiting for payment…',
        AccountBalance: 'Account balance',
        withdrawMethod: 'Withdrawal method',
        withdrawTrx: 'TRX',
        withdrawUsdt: 'USDT',
        withdrawAvailable: 'Available',
        withdrawTip: 'Only one withdrawal request is allowed per month',
        withdrawSelectType: 'Please select a withdrawal method',
        withdrawAmountInvalid: 'Please enter a valid amount',
        withdrawBalanceNotEnough: 'Insufficient balance',
        withdrawRecord: 'Withdrawal history',
        withdrawRecordTotal: 'Total records',
        withdrawApplyTime: 'Applied at',
        withdrawMonth: 'Month',
        withdrawStatusPending: 'Pending',
        withdrawStatusSuccess: 'Success',
        withdrawStatusFail: 'Failed',
        noWithdrawRecords: 'No withdrawal records yet',
        rechargeRecord: 'Recharge history',
        rechargeRecordTotal: 'Total records',
        rechargeApplyTime: 'Ordered at',
        rechargeOrderNo: 'Order no.',
        rechargeStatusWait: 'Waiting',
        rechargeStatusCancel: 'Cancelled',
        rechargeStatusPending: 'Pending payment',
        rechargeStatusPaid: 'Paid',
        rechargeStatusDone: 'Completed',
        noRechargeRecords: 'No recharge records yet',
        redEnvelopeTotal: 'Total envelopes',
        redEnvelopeGrantTime: 'Granted at',
        redEnvelopeClaimTime: 'Claimed at',
        redEnvelopeUnclaimed: 'Unclaimed',
        redEnvelopeOpen: 'Open envelope',
        redEnvelopeScratchHint: 'Prize hidden',
        redEnvelopePrize: 'Prize amount',
        redEnvelopeClaimed: 'Claimed',
        noRedEnvelopeRecords: 'No red envelope records yet',
    },
    treasurePlate: {
        becomeTitle: 'How to become an agent',
        becomeDesc: 'Become an agent by purchasing the annual plan. During the one-year period, you enjoy agent benefits and earn commissions.',
        benefitTitle: 'Agent earnings',
        benefitDesc: 'Agent earnings include: A direct recharge commission and B team recharge commission.',
        directTitle: 'A · Direct recharge commission',
        directTip: 'After becoming an agent, share videos with friends. When they register and buy a plan, you earn commission based on their monthly recharge tier:',
        teamTitle: 'B · Team recharge commission',
        teamIntro: 'When your downline has multiple levels, you can see monthly income contributed by each level to keep growing your team.',
        colRank: 'Rank',
        colAmount: 'Recharge amount',
        colSlogan: 'Slogan',
        goBuyYear: 'Buy annual plan now',
        r1: { title: 'Private, Warrior', amount: '≤ 2k', slogan: 'Solo fighter, first steps' },
        r2: { title: 'Sergeant, Squad leader', amount: '> 2k and ≤ 3k', slogan: 'Lead the squad, show promise' },
        r3: { title: '2nd Lt, Platoon leader', amount: '> 3k and ≤ 4k', slogan: 'Officer rank, own your path' },
        r4: { title: '1st Lt, Company commander', amount: '> 4k and ≤ 5k', slogan: 'Core backbone, mid-tier leader' },
        r5: { title: 'Major, Battalion commander', amount: '> 5k and ≤ 6k', slogan: 'Battalion command, strong force' },
        r6: { title: 'Captain, Regiment commander', amount: '> 6k and ≤ 7k', slogan: 'Stand alone, regional power' },
        r7: { title: 'Lt Colonel, Brigade commander', amount: '> 7k and ≤ 8k', slogan: 'Battlefield veteran, steady command' },
        r8: { title: 'Colonel, Division commander', amount: '> 8k and ≤ 9k', slogan: 'Territorial lord, dominant force' },
        r9: { title: 'Major General, Corps commander', amount: '> 9k and ≤ 10k', slogan: 'Group leader, outstanding merit' },
        r10: { title: 'General, Commander', amount: '> 10k', slogan: 'Supreme commander, unmatched' },
        t1: 'When any account completes a recharge, 2% of the amount is allocated as team commission;',
        t2: 'Find the recharger’s referrer and send 25% of that 2% as a red-packet commission;',
        t3: 'Each upper-level referrer receives 25% of the remaining pool, and so on;',
        t4: 'Any remainder without an upper referrer goes to the platform;',
        t5: 'Recipients get an in-site message for team commission;',
        t6: 'Commission is credited to balance only after clicking “Claim” in the message (ads shown on that page);',
        t7: 'View team commission details by sub-account, time, and amount—but not whether downlines claimed, to motivate team growth.',
    },
    guideText: {
        no1: '- Online shopping brings convenience, initiative, diverse choices, with support services for purchasing, sales, safe payment, professional delivery, Pinggo.vn constantly strives to efforts and improvements to meet consumer shopping needs.',
        no2: '- PingGo\'s products are guaranteed to be genuine from suppliers and brands with competitive prices. When ordering at PingGo, you do not need to worry about quality because the products listed for sale on the floor have been carefully selected and inspected by PingGo.',
        no3: '- We serve 7 days a week.',
        no4: '- Work regulations :',
        no5: '- During work, members must follow the order and in accordance with the system\'s regulations and requirements .',
        no6: '- Pinggo.vn would like to sincerely thank the members who have contributed to accompanying Pinggo Joint Stock Company .',
    },
    revision: {
        password: 'Password',
        withdrawalPassword: 'Withdrawal password',
        withdrawalAccount: 'Withdrawal account',
        currentPassword: 'current password',
        aNewPassword: 'A new password',
        confirmYourPassword: 'Confirm your password',
        realName: 'Real name',
        userNAME: 'User name',
        bankAccount: 'Bank account',
        bankName: 'Bank name',
    },
    order: {
        all: '所有的',
        not: '未解决',
        complete: '完全的',
        frozen: '冷冻的',
    }
}